import { toDateKey } from '../tasks/utils'

/** Monday of the ISO-style week containing `d` (week starts Monday). */
export function mondayOf(d: Date): Date {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate())
  const day = x.getDay()
  const diff = day === 0 ? -6 : 1 - day
  x.setDate(x.getDate() + diff)
  return x
}

/** Monday date key yyyy-MM-dd for the week containing `date`. */
export function toWeekKey(date: Date): string {
  return toDateKey(mondayOf(date))
}

export function currentWeekStartKey(): string {
  return toWeekKey(new Date())
}

/** Seven date keys Mon–Sun for the week starting `weekStart` (Monday yyyy-MM-dd). */
export function weekDateKeys(weekStart: string): string[] {
  const [y, m, d] = weekStart.split('-').map((n) => parseInt(n, 10))
  const start = new Date(y, (m ?? 1) - 1, d ?? 1)
  const keys: string[] = []
  for (let i = 0; i < 7; i++) {
    const dt = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i)
    keys.push(toDateKey(dt))
  }
  return keys
}

/** e.g. "Jun 1" for the Monday of that week. */
export function formatWeekOfLabel(weekStart: string): string {
  const [y, m, d] = weekStart.split('-').map((n) => parseInt(n, 10))
  const date = new Date(y, (m ?? 1) - 1, d ?? 1)
  const now = new Date()
  const opts: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' }
  if (date.getFullYear() !== now.getFullYear()) opts.year = 'numeric'
  return new Intl.DateTimeFormat('en-US', opts).format(date)
}
